<template>
  <div class="fixed inset-0 flex flex-col items-center justify-start pt-8 px-2 overflow-y-auto dark:bg-gray-900"> <!-- Added padding top here -->
    <!-- Title outside the containers -->
    <h2 class="text-center font-bold text-blue-500 dark:text-blue-300 text-xl pb-6">
      WANZAM APP | Circumcision Complication Risks Calculator
    </h2>

    <div class="flex flex-col md:flex-row items-start justify-center w-full">
      <!-- Container 1 content -->
      <div class="w-full md:w-1/3 h-[87vh] bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-lg shadow-lg flex flex-col items-center justify-start mb-4 md:mb-0 overflow-y-auto"> <!-- Added shadow-lg for shadow effect -->
        <!-- Form in container 1 -->
  <form @submit.prevent="calculateRisk" class="flex flex-col items-center gap-2 p-4 w-full">
  <div class="flex flex-col w-full">
    <label for="AGE_CD" class="text-xm mb-1 dark:text-gray-200">Age Category (AGE_CD):</label>
    <select v-model="form.AGE_CD" required class="p-1 rounded border border-gray-300 w-full dark:border-gray-700 dark:bg-gray-700 dark:text-gray-200">
      <option value="" disabled selected></option>
      <option value="0">0 = up to 4 weeks</option>
      <option value="1">1 = 4 weeks to 1 year</option>
      <option value="2">2 = 1 year to 5 years</option>
      <option value="3">3 = 5 to 10 years</option>
      <option value="4">4 = 10 to 20 years</option>
      <option value="5">5 = 20 years and beyond</option>
    </select>
  </div>

  <div class="flex flex-col w-full">
    <label for="OCC_CD" class="text-sm mb-1 dark:text-gray-200">Occupation Category (OCC_CD):</label>
    <select v-model="form.OCC_CD" required class="p-1 rounded border border-gray-300 w-full dark:border-gray-700 dark:bg-gray-700 dark:text-gray-200">
      <option value="" disabled selected></option>
      <option value="0">0 = Unemployed</option>
      <option value="1">1 = Health Professional</option>
      <option value="2">2 = Education (Lecturers, Teachers)</option>
      <option value="3">3 = Clerical, Managerial, Secretarial</option>
      <option value="4">4 = Agriculture, Artisan, Vocational, Housewife, Trader</option>
      <option value="5">5 = Forces, Police, Military, Pastors</option>
      <option value="6">6 = Students</option>
    </select>
  </div>

  <div class="flex flex-col w-full">
    <label for="ED_CD" class="text-sm mb-1 dark:text-gray-200">Education Category (ED_CD):</label>
    <select v-model="form.ED_CD" required class="p-1 rounded border border-gray-300 w-full dark:border-gray-700 dark:bg-gray-700 dark:text-gray-200">
      <option value="" disabled selected></option>
      <option value="0">0 = None</option>
      <option value="1">1 = Primary</option>
      <option value="2">2 = Secondary</option>
      <option value="3">3 = Tertiary</option>
      <option value="4">4 = Islamic Education</option>
    </select>
  </div>

  <div class="flex flex-col w-full">
    <label for="REL_CD" class="text-sm mb-1 dark:text-gray-200">Religion Category (REL_CD):</label>
    <select v-model="form.REL_CD" required class="p-1 rounded border border-gray-300 w-full dark:border-gray-700 dark:bg-gray-700 dark:text-gray-200">
      <option value="" disabled selected></option>
      <option value="1">1 = Christianity</option>
      <option value="2">2 = Islam</option>
      <option value="3">3 = Traditional</option>
      <option value="4">4 = No Religion</option>
    </select>
  </div>

  <div class="flex flex-col w-full">
    <label for="ETH_CD" class="text-sm mb-1 dark:text-gray-200">Ethnicity Category (ETH_CD):</label>
    <select v-model="form.ETH_CD" required class="p-1 rounded border border-gray-300 w-full dark:border-gray-700 dark:bg-gray-700 dark:text-gray-200">
      <option value="" disabled selected></option>
      <option value="1">1 = Ewe</option>
      <option value="2">2 = Ga</option>
      <option value="3">3 = Akan</option>
      <option value="4">4 = Northern Tribes + Hausa</option>
      <option value="5">5 = Igbo, Nigerian/Foreign</option>
    </select>
  </div>

  <div class="flex flex-col w-full">
    <label for="RES_CD" class="text-sm mb-1 dark:text-gray-200">Residence Category (RES_CD):</label>
    <select v-model="form.RES_CD" required class="p-1 rounded border border-gray-300 w-full dark:border-gray-700 dark:bg-gray-700 dark:text-gray-200">
      <option value="" disabled selected></option>
      <option value="1">1 = Rural</option>
      <option value="2">2 = Periurban</option>
      <option value="3">3 = Urban</option>
    </select>
  </div>

  <div class="flex flex-col w-full">
    <label for="FAC_CD" class="text-sm mb-1 dark:text-gray-200">Facility Category (FAC_CD):</label>
    <select v-model="form.FAC_CD" required class="p-1 rounded border border-gray-300 w-full dark:border-gray-700 dark:bg-gray-700 dark:text-gray-200">
      <option value="" disabled selected></option>
      <option value="0">0 = Home Circumcision</option>
      <option value="1">1 = CHPS/Health Centre/Clinic</option>
      <option value="2">2 = District Hospital/Private Hospital</option>
      <option value="3">3 = Specialist Private Facility/Polyclinic/University Hospital</option>
      <option value="4">4 = Teaching Hospital</option>
    </select>
  </div>

  <div class="flex flex-col w-full">
    <label for="Practitioner_Num" class="text-sm mb-1 dark:text-gray-200">Practitioner Number:</label>
    <select v-model="form.Practitioner_Num" required class="p-1 rounded border border-gray-300 w-full dark:border-gray-700 dark:bg-gray-700 dark:text-gray-200">
      <option value="" disabled selected></option>
      <option value="1">1 = Doctor</option>
      <option value="2">2 = Nurse</option>
      <option value="3">3 = Midwife</option>
      <option value="4">4 = Wanzam</option>
      <option value="5">5 = Herbalist</option>
    </select>
  </div>

  <button type="submit" class="p-3 mt-4 bg-blue-500 dark:bg-blue-700 text-white font-bold rounded w-full hover:bg-blue-700 dark:hover:bg-blue-900 self-stretch">
    Calculate Risk
  </button>
</form>
      </div>
      <!-- Container 2 content -->
      <div class="w-full md:w-1/3 h-[87vh] bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-lg shadow-lg flex flex-col justify-start mb-4 md:mx-2 overflow-y-auto"> <!-- Added shadow-lg for shadow effect -->
        <div class="p-4 text-left w-full">
          <h3 class="text-sm mb-2 dark:text-gray-200 pb-4 ">Predicted Probability of Circumcision Complications</h3>
          <p class="text-base text-gray-800 dark:text-gray-300" v-if="result.probability">{{ result.probability }}</p>
          <p class="text-sm text-gray-800 dark:text-gray-300 pb-4" v-else>No probability calculated yet.</p>

          <div class="h-px bg-gray-300 my-4"></div>

          <h3 class="text-sm mb-2 dark:text-gray-200 pb-4">Medical Advice</h3>
          <p class="text-base text-gray-800 dark:text-gray-300" v-if="result.advice">{{ result.advice }}</p>
          <p class="text-sm text-gray-800 dark:text-gray-300" v-else>Awaiting medical advice.</p>

          <div class="h-px bg-gray-300 my-4"></div>

          <h3 class="text-sm mb-2 dark:text-gray-200 pb-4">Next Steps</h3>
          <p class="text-base text-gray-800 dark:text-gray-300" v-if="result.next_step">{{ result.next_step }}</p>
          <p class="text-sm text-gray-800 dark:text-gray-300" v-else>Next steps will be displayed after calculation.</p>
        </div>
      </div>

      <!-- Container 3 content with smaller text to fit content -->
      <div class="w-full md:w-1/3 h-[87vh] bg-white dark:bg-gray-800 dark:text-gray-300 border border-gray-300 dark:border-gray-700 rounded-lg shadow-lg flex flex-col items-center justify-start mb-4 overflow-y-auto"> <!-- Added shadow-lg for shadow effect -->
        <h3 class="text-left text-sm w-full pl-4 pt-4 dark:border-gray-300">Code Guide for Predictors</h3>

        <div class="bg-gray-200 dark:bg-gray-700 text-black dark:text-gray-200 p-4 mt-4 rounded-lg text-left text-base w-11/12">
          <pre class="whitespace-pre-wrap text-xs">{{ code_guide_combined }}</pre>
        </div>

      <!-- Container 3 - Accordion FAQ Section -->
        <div class="faq-section mt-8 p-6 bg-gray-100 dark:bg-gray-800 rounded-lg transition-colors duration-300">
          <h3 class="text-left text-sm mb-4 text-gray-700 dark:text-gray-300">
            Frequently Asked Questions (FAQs)
          </h3>

          <div v-for="(faq, index) in faqs" :key="index" class="faq-card mb-4">
    
    <!-- Accordion Button (Question) -->
        <button
          @click="toggleFAQ(index)"
          class="w-full text-left p-4 bg-gray-200 dark:bg-gray-700 text-black dark:text-gray-200 rounded-lg focus:outline-none hover:shadow-lg transition-shadow duration-300"
        >
          <h4 class="text-sm">{{ faq.question }}</h4>
        </button>

    <!-- Accordion Answer -->
          <p v-if="faq.active" class="mt-2 p-4 text-left text-sm text-gray-700 dark:text-gray-300 bg-gray-50 dark:bg-gray-800 border dark:border-gray-700 rounded-lg transition-colors duration-300">
            {{ faq.answer }}
          </p>
        </div>
      </div>
        </div>
      </div>
    </div>
</template>

<style>
  html,
  body {
    height: 100%;
    margin: 0;
    padding: 0;
  }
</style>

<script>
import { API_SERVER } from "../constant";

export default {
  data() {
    return {
      form: {
        AGE_CD: '',
        OCC_CD: '',
        ED_CD: '',
        REL_CD: '',
        ETH_CD: '',
        RES_CD: '',
        FAC_CD: '',
        Practitioner_Num: '',
      },
      result: {
        probability: null,
        advice: null,
        next_step: null,
      },
      code_guide_combined: `
AGE_CD: Age Category (0-5)
OCC_CD: Occupation Category (0-6)
ED_CD: Education Category (0-4)
REL_CD: Religion Category (1-4)
ETH_CD: Ethnicity Category (1-5)
RES_CD: Residence Category (1-3)
FAC_CD: Facility Category (0-4)
Practitioner_Type: Number of Practitioners (1-5)
      `,
      // Place FAQs inside the data function
      faqs: [
        { question: "What is the purpose of this app?", answer: "This app calculates the risk of circumcision mishaps based on various provider-related and demographic factors." },
        { question: "How does the risk calculation work?", answer: "The app uses data from our detailed study to analyze specific factors and provide a personalized risk assessment." },
        { question: "Who can use this app?", answer: "The app is designed for individuals considering circumcision, public health officers, caregivers, or providers involved in the procedure. It is also deployed as a hospital assistive device." },
        { question: "Is my personal information safe?", answer: "Yes, we prioritize your privacy and confidentiality. All data is securely stored and used only for risk assessment." },
        { question: "What should I do if the app indicates a high risk?", answer: "If a high risk is indicated, we recommend consulting a healthcare professional for further evaluation and guidance." },
        { question: "Can this app replace professional medical advice?", answer: "No, this app is a tool for assessment and should not replace professional medical advice. Always consult a healthcare provider for medical concerns." },
        { question: "Who can I contact for further advice on the next steps?", answer: "Send a WhatsApp message to +233275543382." },
        { question: "What are common circumcision mishaps in Ghana and globally?", answer: "Common mishaps include excessive bleeding, infection, improper removal of foreskin, and injury to surrounding areas." },
        { question: "What are the dangers of home circumcision?", answer: "Home circumcision can lead to severe complications, including excessive bleeding, infection, and transmission of bloodborne infections like HIV and hepatitis." },
        { question: "What is neonatal or adult tetanus, and how is it related to circumcision?", answer: "Tetanus is a serious bacterial infection. In non-sterile environments, it can occur after circumcision, especially if proper hygiene is not maintained." },
        // Add more FAQs as needed based on the document
      ]
    };
  },
  methods: {
    toggleFAQ(index) {
      // Toggle the 'active' state of the clicked FAQ
      this.faqs[index].active = !this.faqs[index].active;
    },
    async calculateRisk() {
      try {
        const response = await fetch(API_SERVER + "/api/calculate", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(this.form),
        });

        if (!response.ok) {
          throw new Error(`Error: ${response.statusText}`);
        }

        const data = await response.json();
        this.result = data;
      } catch (error) {
        console.error("Error calculating risk:", error);
        alert("There was an error calculating the risk. Please try again.");
      }
    },
  },
};
</script>
